module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre6",
    attrs: {
      "id": "pgepubid00027"
    }
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "CONTENTS"
    }
  }), _vm._v("CONTENTS.")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('table', {
    staticClass: "tabc",
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre13"
  }, [_c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_c('br', {
    staticClass: "calibre7"
  })]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_vm._v("PAGE"), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre7"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("NOTICES OF AN INDEPENDENT PRESS")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0003.htm#Page_xxix"
    }
  }, [_vm._v("xxix")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No. I.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("A LETTER FROM MR. EZEKIEL BIGLOW OF JAALAM TO THE HON. JOSEPH T. BUCKINGHAM, EDITOR OF THE BOSTON COURIER, INCLOSING A POEM OF HIS SON, MR. HOSEA BIGLOW")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0006.htm#Page_1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No. II.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("A LETTER FROM MR. HOSEA BIGLOW TO THE HON. J. T. BUCKINGHAM, EDITOR OF THE BOSTON COURIER, COVERING A LETTER FROM MR. B. SAWIN, PRIVATE IN THE MASSACHUSETTS REGIMENT")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0007.htm#Page_11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No. III.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("WHAT MR. ROBINSON THINKS")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0008.htm#Page_27"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No. IV.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("REMARKS OF INCREASE D. O'PHACE, ESQUIRE, AT AN EX-TRUMPERY CAUCUS IN STATE STREET, REPORTED BY MR. H. BIGLOW")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0009.htm#Page_40"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No. V.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("THE DEBATE IN THE SENNIT. SOT TO A NUSRY RHYME")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0011.htm#Page_55"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No. VI.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("THE PIOUS EDITOR'S CREED")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0012.htm#Page_64"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No. VII.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("A LETTER FROM A CANDIDATE FOR THE PRESIDENCY IN ANSWER TO SUTTIN QUESTIONS PROPOSED BY MR. HOSEA BIGLOW, INCLOSED IN A NOTE FROM MR. BIGLOW TO S. H. GAY, ESQ., EDITOR OF THE NATIONAL ANTISLAVERY STANDARD")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0013.htm#Page_74"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No. VIII.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("A SECOND LETTER FROM B. SAWIN, ESQ.")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0014.htm#Page_86"
    }
  }, [_vm._v("86")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No. IX.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("A THIRD LETTER FROM B. SAWIN, ESQ.")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0015.htm#Page_106"
    }
  }, [_vm._v("106")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("GLOSSARY")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0016.htm#Page_127"
    }
  }, [_vm._v("127")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "ct"
  }, [_vm._v("INDEX")]), _vm._v(" "), _c('td', {
    staticClass: "ct1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "href": "#/OEBPS/Text/Section0017.htm#Page_131"
    }
  }, [_vm._v("131")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_xxix",
      "title": "[Pg xxix]"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b67c9650","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section0003.vue
// module id = 63
// module chunks = 0